import styled from '@emotion/styled';
import { TagButtonWrap } from '../../../../ui';

export const FlightScopeButtons = styled(TagButtonWrap)`
	margin-bottom: 16px;
`;
